var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, EventEmitter, Output } from '@angular/core';
var GraphStatesComponent = /** @class */ (function () {
    function GraphStatesComponent() {
        this.selectedStateChange = new EventEmitter();
    }
    Object.defineProperty(GraphStatesComponent.prototype, "selectedState", {
        get: function () {
            return this._selectedState;
        },
        set: function (state) {
            if (state === this._selectedState) {
                return;
            }
            this._selectedState = state;
            this.selectedStateChange.emit(state);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input()
    ], GraphStatesComponent.prototype, "states", void 0);
    __decorate([
        Output()
    ], GraphStatesComponent.prototype, "selectedStateChange", void 0);
    __decorate([
        Input()
    ], GraphStatesComponent.prototype, "selectedState", null);
    GraphStatesComponent = __decorate([
        Component({
            selector: 'graph-states',
            template: "<div *ngFor=\"let state of states\" class=\"graphList\"> <div *ngIf=\"state.url\" class=\"graph\" (click)=\"selectedState=state\" [class.selectedGallery]=\"state==selectedState\"> <img src=\"{{state.url}}\" crossorigin=\"anonymous\" width=\"100%\" height=\"100%\" alt=\"\"> </div> <span>{{state.name}}</span> </div> ",
            styles: [" .graphList { text-align: center; float: left; width: 64px; height: 100px; margin-left: 10px; margin-top: 10px; .graph { width: 64px; height: 64px; border: 2px solid transparent; display: flex; cursor: pointer; justify-content: center; .svgGraph>svg { width: 100%; height: 100%; } img{ width: auto; height: auto; max-width: 100%; max-height: 100%; align-self: center; } } span { font-size: 12px; word-break: break-word; } .graph.selectedGallery { border-color: #2d89ef; } } .inline-control{ display: inline-block; }"]
        })
    ], GraphStatesComponent);
    return GraphStatesComponent;
}());
export { GraphStatesComponent };
